<script setup lang="ts">
/** Leave quiz — Modal 440 over the step ("Exit the quiz?"). Copy differs per flow. */
import { FairDialog } from '@/ui/primitives/FairDialog'

interface FairQuizLeaveDialogProps {
  visible?: boolean
  title: string
  text: string
  keepLabel: string
  exitLabel: string
  closeLabel?: string
}

withDefaults(defineProps<FairQuizLeaveDialogProps>(), {
  visible: false,
  closeLabel: 'Close',
})

const emit = defineEmits<{
  'update:visible': [value: boolean]
  keep: []
  exit: []
}>()

function keep() {
  emit('update:visible', false)
  emit('keep')
}
</script>

<template>
  <FairDialog
    :visible="visible"
    :header="title"
    :content-text="text"
    :cancel-label="keepLabel"
    :confirm-label="exitLabel"
    :close-label="closeLabel"
    width="440px"
    size="auto"
    @update:visible="(value) => !value && keep()"
    @cancel="keep"
    @confirm="emit('exit')"
  />
</template>
